<template>
  <div class="header-container" :class="{ 'header-scrolled': isScrolled }">
    <div class="container">
      <img :style="{
        width: moduleAttribute.logoWidth,
        height: moduleAttribute.logoHeight,
      }" :src="moduleAttribute.logoSrc"/>
      <!-- 桌面端导航菜单：不变 -->
      <nav class="desktop-nav">
        <ul class="main-menu">
          <template v-for="item in filteredComponentList">
            <li 
              v-if="!item.componentList || !item.componentList.length"
              :key="item.id"
              :style="getNavItemStyle()"
              class="menu-item"
              v-theme.$store.hover="{ color: moduleAttribute.isCustomColor && moduleAttribute.childFontActivieColor ? moduleAttribute.childFontActivieColor : 'var(--theme-GLOBAL_COLOR)'}"
              :class="{ 'active': activeMenu === item.id + '' }"
              @click="handleMenuSelect(item.id + '')"
            >
              {{ item.componentAlias }}
            </li>
            <li 
              v-else
              :key="item.id"
              class="menu-item has-children"
              :style="getNavItemStyle()"
              :class="{ 'active': activeMenu === item.id + '', 'submenu-open': openSubmenuId === item.id }"
              @mouseenter="openSubmenu(item.id)"
              @mouseleave="closeSubmenu"
            >
              <span class="submenu-title" v-theme.$store.hover="{ color: moduleAttribute.isCustomColor && moduleAttribute.childFontActivieColor ? moduleAttribute.childFontActivieColor : 'var(--theme-GLOBAL_COLOR)'}">{{ item.componentAlias }}</span>
              <transition name="slide-fade">
                <ul class="submenu" v-show="openSubmenuId === item.id">
                  <li 
                    v-for="child in item.componentList"
                    :style="getMenuItemStyle()"
                    :key="child.id"
                    class="submenu-item"
                    :class="{ 'active': activeMenu === child.id + '' }"
                    @click="handleMenuSelect(child.id + '')"
                  >
                    <span class="menu-text"  v-theme.$store.hover="{ color:  moduleAttribute.isCustomColor && moduleAttribute.childFontActivieColor ? moduleAttribute.childFontActivieColor : 'var(--theme-GLOBAL_COLOR)',backgroundColor: moduleAttribute.isCustomColor && moduleAttribute.childActiveBgColor ? moduleAttribute.childActiveBgColor : '#ffffff'}"> {{ child.componentAlias }}  </span>
                  </li>
                </ul>
              </transition>
            </li>
          </template>
        </ul>
      </nav>
      <div class="search-box" @click="searchVisible = true">
        <el-input
          v-if="moduleAttribute.isShowSearch"
          placeholder="关键词搜索"
          :readonly="true"
          style="border-radius: 16px;width: 168px;height: 33px; flex-shrink: 0"
          >
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <!-- 功能区：不变 -->
      <div class="header-actions">
        <button class="mobile-menu-btn" @click="toggleMobileMenu">
          <i class="el-icon-menu"></i>
        </button>
      </div>
    </div>

    <!-- 移动端导航菜单：关键修改 - 增加层级视觉区分+阻止事件冒泡 -->
    <div class="mobile-nav" v-if="showMobileMenu">
      <ul class="mobile-menu">
        <template v-for="item in filteredComponentList">
          <!-- 无下级菜单的一级项 -->
          <li 
            v-if="!item.componentList || !item.componentList.length"
            :key="item.id"
            class="mobile-menu-item"
            :class="{ 'active': activeMenu === item.id + '' }"
            @click="handleMenuSelect(item.id + '', true)"
          >
            {{ item.componentAlias }}
          </li>
          <!-- 有下级菜单的一级项：关键修改@click.stop -->
          <li 
            v-else
            :key="item.id"
            class="mobile-menu-item has-children"
            :class="{ 'active': activeMenu === item.id + '', 'submenu-open': openSubmenuId === item.id }"
          >
            <!-- 一级项标题：添加箭头+@click.stop阻止冒泡 -->
            <div class="mobile-parent-item" @click.stop="toggleSubmenu(item.id)">
              <span class="submenu-title">{{ item.componentAlias }}</span>
              <i class="el-icon-arrow-down mobile-submenu-arrow" :class="{ 'rotate': openSubmenuId === item.id }"></i>
            </div>
            <!-- 子菜单：修改动画+层级样式 -->
            <transition name="slide-down">  <!-- 换为高度展开动画，更适合移动端 -->
              <ul class="mobile-submenu" v-show="openSubmenuId === item.id">
                <li 
                  v-for="child in item.componentList"
                  :key="child.id"
                  class="mobile-submenu-item"
                  :class="{ 'active': activeMenu === child.id + '' }"
                  @click="handleMenuSelect(child.id + '', true)"
                >
                  {{ child.componentAlias }}
                </li>
              </ul>
            </transition>
          </li>
        </template>
      </ul>
    </div>
      <el-dialog
        :visible.sync="searchVisible"
        width="45%"
        custom-class="custom-dialog-class"
        append-to-body
        :show-close="false"
        @close="onDialogClose"
    >
      <div class="search-div">
        <el-input
            placeholder="请输入关键词搜索"
            v-model="search"
            @keyup.enter.native="handleSearch"
            clearable>
          <i slot="suffix"
             class="el-input__icon el-icon-search search-icon"
             @click="handleSearch"></i>
        </el-input>
        <i @click="searchVisible = false" class="el-icon-close custom-close"></i>
      </div>

      <!-- 搜索结果列表 -->
      <div v-if="searchResults.length > 0" class="search-results">
        <div class="results-container">
          <div @click="jumpDetail(item)" v-for="(item, index) in filteredResults" :key="index" class="result-item">
            <div class="result-header">
              <span class="result-type">{{ item.type }}</span>
              <span class="result-title" @click="openArticle(item)">{{ item.title }}</span>
            </div>
            <div class="result-meta">
              <span class="result-date">{{ item.date }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 搜索中状态 -->
      <div v-else-if="loading" class="loading-state">
        <el-spinner></el-spinner>
        <p>正在搜索...</p>
      </div>

      <!-- 无搜索结果状态 -->
      <div v-else-if="!loading && search" class="no-results">
        <i class="el-icon-warning"></i>
        <p>未找到相关文章</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 脚本部分仅新增1个参数（控制移动端菜单关闭），其余不变
import { commonMixin } from "@/mixins/analysisMixin.js";
import themeMixin from '@/mixins/theme'
import {commmonAjax} from "@/api/common";

export default {
  name: 'desktopNavModule',
  mixins: [themeMixin, commonMixin],
  props: {
    moduleData: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      searchQuery: '',
      activeMenu: '/',
      showMobileMenu: false,
      isScrolled: false,
      openSubmenuId: null,
      searchVisible: false,
      search: '',
      searchResults: [],
      loading: false,
      activeTab: '全部',
      tabs: [
        { name: '全部', label: '全部' },
        { name: '新闻', label: '新闻' },
        { name: '活动', label: '活动' },
        { name: '风采', label: '风采' }
      ]
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
    this.setActiveMenu()
    this.$router.afterEach(() => {
      this.setActiveMenu()
      this.showMobileMenu = false
      this.openSubmenuId = null  // 路由切换重置子菜单
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    filteredResults() {
      return this.searchResults.filter(item => {
        if (this.activeTab === '全部') return true;
        return item.type === this.activeTab;
      });
    },
    componentList() {
      return this.getComponListAttribute(this.moduleData.componentList, 887)
    },
    hoverStyles() {
      const color = this.moduleAttribute.isCustomColor && this.moduleAttribute.childFontActivieColor 
        ? this.moduleAttribute.childFontActivieColor 
        : 'var(--theme-GLOBAL_COLOR)';
      
      const backgroundColor = this.moduleAttribute.isCustomColor && this.moduleAttribute.childActiveBgColor 
        ? this.moduleAttribute.childActiveBgColor 
        : '#ffffff';
      
      return {
        color,
        backgroundColor
      };
    },
    moduleStyle() {
      let style = {}
      if (this.moduleAttribute.options) {
        style = { ...this.moduleAttribute.options }
      }
      return style
    },
    filteredComponentList() {
      if (!this.moduleData || !this.moduleData.componentList) return [];
      return this.filterHiddenComponents(this.moduleData.componentList);
    }
  },
  methods: {
    // 跳转详情
    jumpDetail(item) {
      this.moduleAttribute.isOpenTab = true
      if (this.moduleAttribute.isOpenTab) {
        const routeData = this.$router.resolve({
          name: 'InformationDetail',
          query: { type: 'informDetail',  typeId: item.id }
        });
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push({
          path: '/information-detail',
          query: {
            type: 'informDetail',
            typeId: item.id
          }
        })
        this.searchVisible = false
      }
    },
    handleSearch() {
      if (!this.search.trim()) return;

      this.loading = true;
      this.searchResults = [];

      let params = {
        url: `/websiteDesign/list-informationDelivery`,
        query: {
          title: this.search,
          type: '',
          sortRules: '',
          isHomePage: ''
        },
        method: 'get'
      }

      commmonAjax(params).then(res => {
        console.log(res, 'ressssssssssss')
        if (res.resultCode === '200') {
          this.searchResults = res.resultData.list.map(item => ({
            id: item.id,
            title: item.title,
            type: item.type || '全部',
            date: item.date,
          }));
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },

    openArticle(article) {
      if (article.url) {
        window.open(article.url, '_blank');
      }
    },

    onDialogClose() {
      this.search = '';
      this.searchResults = [];
      this.loading = false;
      this.activeTab = '全部';
    },
    filterHiddenComponents(components) {
      return components.filter(component => {
        let isShow = true;
        try {
          let styleDataStr = component.styleData || '';
          styleDataStr = styleDataStr.replace(/isHidden:\s*/g, '"isHidden":');
          styleDataStr = styleDataStr.replace(/([{,]\s*)(\w+):/g, '$1"$2":');
          let styleData = {}
          if (!styleDataStr) {
            styleData.isHidden = false
          } else {
            styleData = JSON.parse(styleDataStr);
          }
          if (styleData.isHidden === true) isShow = false;
          if (styleData.componentData && styleData.componentData.length > 0) {
            const firstItem = styleData.componentData[0];
            if (firstItem.isHidden === true) isShow = false;
          }
        } catch (error) {
          // isShow = false;
        }
        if (isShow && component.componentList && component.componentList.length > 0) {
          component.componentList = this.filterHiddenComponents(component.componentList);
        }
        return isShow;
      });
    },
    getNavItemStyle() {
      let style = {
      }
      style.fontSize = this.moduleAttribute.navFontSize
      style.fontWeight = this.moduleAttribute.navTitleBold
      style['min-width'] = `calc(${this.moduleAttribute.navItemWidth} + 15px)`
      return style
    },
    getMenuItemStyle() {
      let style = {
        'min-width': `calc(${this.moduleAttribute.navItemWidth} + 15px)`,
        color: this.moduleStyle.color || '#666'
      }
      if (this.moduleAttribute.isCustomColor) {
        style.color = this.moduleAttribute.childFontColor
        style.background = this.moduleAttribute.childBgColor
        style.fontSize = this.moduleAttribute.childFontSize
      }
      return style
    },

    setActiveMenu() {
      const currentPath = this.$route.path
      if (currentPath.startsWith('/about/')) {
        this.activeMenu = 'about'
      } else {
        this.activeMenu = currentPath
      }
    },

    // 关键修改：新增mobile参数，点击后关闭移动端导航
    handleMenuSelect(index, mobile = false) {
      const menuItem = this.findMenuItemById(this.filteredComponentList, parseInt(index));
      if (menuItem) {
        try {
          const styleData = JSON.parse(menuItem.styleData);
          if (styleData.componentData && styleData.componentData.length > 0) {
            const { url, transferUrl, model } = styleData.componentData[0];
            if (model === 'outLink') {
              window.open(transferUrl, '_blank');
              mobile && (this.showMobileMenu = false);  // 外部链接关闭导航
              return
            }
            if (transferUrl === '/home') {
              if (this.$route.path === '/home') return;
              this.$router.push({ path: '/home' });
              mobile && (this.showMobileMenu = false);  // 首页关闭导航
              return
            }
            this.$router.push({
              path: '/information-detail',
              query: { typeName: menuItem.componentName, url: url }
            });
            mobile && (this.showMobileMenu = false);  // 详情页关闭导航
          }
        } catch (error) {
          console.error('解析 styleData 失败:', error);
        }
      }
      this.$nextTick(() => {
        this.setActiveMenu();
        this.openSubmenuId = null;  // 重置子菜单
      });
    },

    findMenuItemById(componentList, id) {
      for (const item of componentList) {
        if (item.id === id) return item;
        if (item.componentList && item.componentList.length > 0) {
          const result = this.findMenuItemById(item.componentList, id);
          if (result) return result;
        }
      }
      return null;
    },

    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
      // 新增：菜单展开时禁止页面滚动
      document.body.style.overflow = this.showMobileMenu ? 'hidden' : 'auto';
    },

    handleScroll() {
      this.isScrolled = window.scrollY > 50;
      // 新增：滚动时关闭移动端菜单
      if (this.isScrolled && this.showMobileMenu) {
        this.showMobileMenu = false;
        document.body.style.overflow = 'auto';
      }
    },

    openSubmenu(id) {
      this.openSubmenuId = id;
    },

    closeSubmenu() {
      this.openSubmenuId = null;
    },

    toggleSubmenu(id) {
      this.openSubmenuId = this.openSubmenuId === id ? null : id;
    }
  }
}
</script>

<style lang="scss" scoped>
/* 核心修改：移动端菜单层级样式+交互反馈 */
.header-container {
  position: relative;
  height: 70px;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.header-scrolled {
  height: 60px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
  background-color: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(5px);
}

.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0 100px;
  box-sizing: border-box;
}

/* Logo样式：确保移动端不换行 */
.logo-container {
  display: flex;
  align-items: center;
}

.logo-link {
  text-decoration: none;
}

.logo {
  display: flex;
  align-items: center;
}

.logo .el-icon-medkit {
  font-size: 24px;
  color: #5B6EF7;
  margin-right: 8px;
}

.logo-text {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;  /* 防止Logo文字换行 */
}

/* 桌面端导航：不变 */
.desktop-nav {
  width: 100%;
  width: fit-content;
  margin: 0 auto;
}

.main-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.menu-item {
  position: relative;
  font-size: 15px;
  padding: 0 10px;
  width: 76px;
  text-align: center;
  cursor: pointer;
  line-height: 70px;
  transition: all 0.2s ease;
}
.has-children .submenu-title {
  display: block;
  line-height: 70px;
  cursor: pointer;
}

.has-children .submenu {
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  list-style: none;
  min-width: 150px;
  padding: 0;
  z-index: 1001;
}

.submenu-item {
  font-size: 14px;
  cursor: pointer;
  height: 55px;
  line-height: 55px;
  white-space: nowrap;
  transition: all 0.1s ease; /* 缩短到0.1秒 */
  .menu-text {
    display: inline-block;
    width: 100%;
    height: 55px;
    padding: 0 20px;
    box-sizing: border-box;
    line-height: 55px;
  }
}
.submenu-item:hover {
  font-weight: bold;
}

.header-actions {
  display: flex;
  align-items: center;
}

.search-container {
  margin-right: 15px;
}

.search-input {
  width: 180px;
  transition: width 0.3s ease;
}

.search-input:focus {
  width: 220px;
}

.user-menu {
  margin-right: 15px;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 20px;
  transition: background-color 0.2s ease;
}

.user-info:hover {
  background-color: #f5f7fa;
}

.user-avatar {
  width: 32px;
  height: 32px;
  margin-right: 8px;
}

.user-name {
  font-size: 14px;
  margin-right: 5px;
}

/* 移动端菜单按钮：增大触摸区域 */
.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  font-size: 24px;  /* 增大图标 */
  cursor: pointer;
  padding: 12px;  /* 触摸区域≥44px */
  color: #333;
}

/* 移动端导航容器：全屏覆盖+禁止滚动 */
.mobile-nav {
  display: none;
  position: fixed;  /* 改为固定定位，不随页面滚动 */
  top: 70px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  padding: 10px 0;  /* 上下内边距，避免菜单贴边 */
  z-index: 999;
  overflow-y: auto;  /* 子菜单多时有滚动条 */
}

/* 移动端一级菜单：明确样式+触摸区域 */
.mobile-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-menu-item {
  line-height: 50px;  /* 触摸区域≥44px */
  padding: 0 20px;    /* 左右内边距，区分层级 */
  border-bottom: 1px solid #f5f5f5;  /* 分隔线，一级项清晰 */
  cursor: pointer;
  transition: background-color 0.2s ease;
}

/* 有子菜单的一级项标题：flex布局+箭头 */
.mobile-parent-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}

/* 移动端箭头：展开时旋转 */
.mobile-submenu-arrow {
  font-size: 16px;
  transition: transform 0.2s ease;
}

.mobile-submenu-arrow.rotate {
  transform: rotate(180deg);  /* 展开时箭头朝下 */
}

/* 移动端子菜单：层级缩进+背景色区分 */
.mobile-submenu {
  list-style: none;
  padding: 0 0 0 30px;  /* 左侧缩进30px，明确二级菜单 */
  margin: 0;
  background-color: #fafafa;  /* 背景色区分一级菜单 */
}

/* 移动端子菜单项：单独样式，避免继承一级项 */
.mobile-submenu-item {
  font-size: 14px;
  line-height: 48px;  /* 触摸区域≥44px */
  color: #666;  /* 颜色稍浅，区分一级项 */
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.2s ease;
}
.mobile-submenu-item:hover {
  font-weight: bold;
}

/* 响应式断点：确保移动端只显示移动端菜单 */
@media (max-width: 1200px) {
  .desktop-nav {
    display: none;
  }

  .search-container {
    display: none;
  }

  .mobile-menu-btn {
    display: block;
  }
  .search-box {
    display: none;
  }
  .mobile-nav {
    display: block;
  }
}

@media (max-width: 576px) {
  .logo-text {
    font-size: 16px;
  }

  .user-name {
    display: none;
  }

  /* 超小屏：调整菜单间距 */
  .mobile-menu-item {
    padding: 0 15px;
    line-height: 48px;
  }

  .mobile-submenu {
    padding-left: 25px;
  }

  .mobile-submenu-item {
    line-height: 45px;
  }
}

/* 桌面端子菜单动画：不变 */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

/* 新增：移动端子菜单高度展开动画（更适合一级一级展示） */
.slide-down-enter-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
  max-height: 500px;  /* 足够大的高度容纳子菜单 */
  opacity: 1;
  overflow: hidden;  /* 防止内容溢出 */
}

.slide-down-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
  max-height: 0;  /* 收起时高度为0 */
  opacity: 0;
  overflow: hidden;
}

.slide-down-enter, .slide-down-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}
::v-deep .el-input__inner {
  border-radius: 16px;
  height: 33px;
  color: #9d9d9d;
}

::v-deep .el-dialog {
  border-radius: 12px;
  height: 60vh;
}
.search-div {
  display: flex;
  align-items: center;

  .custom-close {
    margin-left: 10px;
    font-size: 22px;
    transition: transform 0.3s ease; /* 添加过渡效果 */
  }

  .custom-close:hover {
    transform: rotate(90deg); /* 鼠标悬停时旋转 */
  }
}
::v-deep .el-dialog__body{
  padding: 0 20px;
}


.search-results {
  margin-top: 20px;
  padding: 15px;
  border-radius: 8px;

  .search-tabs {
    display: flex;
    gap: 15px;
    margin-bottom: 15px;

    .tab-item {
      padding: 8px 12px;
      cursor: pointer;
      font-size: 14px;
      border-bottom: 2px solid transparent;

      &.active {
        color: var(--theme-GLOBAL_COLOR);
        border-bottom-color: var(--theme-GLOBAL_COLOR);
      }
    }
  }

  .results-container {
    max-height: 45vh;
    overflow-y: auto;
    border: 1px solid #eee;
    border-radius: 4px;

    .result-item {
      padding: 12px 15px;
      border-bottom: 1px solid #eee;
      cursor: pointer;

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        background-color: #f0f7ff;
      }

      .result-header {
        display: flex;
        align-items: center;
        margin-bottom: 5px;

        .result-type {
          font-size: 12px;
          color: #666;
          padding: 2px 6px;
          background-color: #eef2f7;
          border-radius: 4px;
          margin-right: 8px;
        }

        .result-title {
          font-size: 14px;
          color: #333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: calc(100% - 60px);
        }
      }

      .result-meta {
        font-size: 12px;
        color: #999;
      }
    }
  }
}

.loading-state {
  text-align: center;
  padding: 40px 0;

  p {
    margin-top: 10px;
    color: #666;
  }
}

.no-results {
  text-align: center;
  padding: 40px 0;
  color: #999;

  i {
    font-size: 24px;
    margin-bottom: 10px;
  }
}
</style>